import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ax from "../config";
import {openNotification} from "../../components/helpers/notification";

const initialState = {
    versions: null,
    currentVersion: null,
    isLoading: false,
}

export const versionAction = createAsyncThunk(
    'versions/versionAction',
    async (payload, { rejectWithValue }) => {
        try {
            let data;
            const url = '/api/admin/version';
            switch (payload.flag) {
                case 'get':
                    ({data} = await ax.get(url, {params: payload.value}))
                    return data

                case 'post':
                    ({data} = await ax.post(url, payload.value))
                    data && openNotification({
                        type: 'success',
                        message: `Версия успешно отредактирована`
                    })
                    break;

                case 'put':
                    ({data} = await ax.put(url, payload.value))
                    data && openNotification({
                        type: 'success',
                        message: `Версия успешно добавлена`
                    })
                    break;

                case 'delete':
                    ({data} = await ax.delete(url, { params: payload.value }))
                    data && openNotification({
                        type: 'success',
                        message: `Версия успешно удалена`
                    })
                    break;

                default:
                    break;
            }
        } catch (error) {
            return rejectWithValue(`Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`)
        }
    }
)

export const versionsSlice = createSlice({
    name: "versions",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(versionAction.fulfilled, (state, action) => {
            state.isLoading = false
            state.versions = action.payload
        })
        builder.addCase(versionAction.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(versionAction.rejected, (state, action) => {
            state.isLoading = false
            openNotification({
                type: "error",
                message: action.payload
            })
        })
    }
})

export const {} = versionsSlice.actions;
export default versionsSlice.reducer